export default {"src":"/_next/static/media/SmartHome.ff70e0ec.svg","height":45,"width":43,"blurWidth":0,"blurHeight":0};